"use client"
import React, { useState, useEffect, useCallback } from "react";
import { useConfig } from "@/lib/providers/ConfigProvider";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha
} from "react-google-recaptcha-v3";

const ReCAPTCHAv3Button = ({
  onVerify,
  style,
  disabled,
  action,
  containerId,
  children
}) => {
  const { recaptchaSiteKey } = useConfig();
  const WrapperButton = ({ onVerify, children }) => {
    // const [token, setToken] = useState(null);

    const { executeRecaptcha } = useGoogleReCaptcha();

    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async () => {
      // console.log("handleReCaptchaVerify", executeRecaptcha);
      if (!executeRecaptcha) {
        // console.log("Execute recaptcha not yet available");
        return;
      }
      const token = await executeRecaptcha(action ?? "defaultAction");
      if (token) {
        onVerify(true);
      } else {
        console.log("ReCAPTCHA failed");
      }
    }, [executeRecaptcha]);

    return (
      <button
        type="button"
        className="btn btn-primary"
        style={style}
        disabled={disabled}
        onClick={() => {
          handleReCaptchaVerify();
        }}
      >
        {children}
      </button>
    );
  };

  const [containerElement, setContainerElement] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (containerId && !loaded) {
      var element = document.getElementById(containerId);
      // console.log(element);
      setContainerElement(element);
    }
    setLoaded(true);
  }, []);

  if (containerElement && loaded) {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaSiteKey}
        container={{
          element: containerElement
        }}
      >
        <WrapperButton onVerify={onVerify}>{children}</WrapperButton>
      </GoogleReCaptchaProvider>
    );
  } else if (loaded) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
        <WrapperButton onVerify={onVerify}>{children}</WrapperButton>
      </GoogleReCaptchaProvider>
    );
  } else {
    return <></>;
  }
};
export default ReCAPTCHAv3Button;
